'use strict';

export const xhrAddressSuggestions = search => {
    return new Promise((resolve, reject) => {
        const http = new XMLHttpRequest();
        http.responseType = 'json';
        const url = `/kvbm/location/autocomplete?search=${search}`;
        http.open('GET', url, true);
        http.onreadystatechange = () => {
            if (http.readyState === 4 && http.status === 200 && http.response !== null) {
                resolve(http);
            } else if (http.readyState === 4 && http.status !== 200) {
                reject(http);
            }
        };
        http.send();
    });
};

export const xhrAddressGeocode = search => {
    return new Promise((resolve, reject) => {
        const http = new XMLHttpRequest();
        http.responseType = 'json';
        const url = `/kvbm/location/geocode?search=${search}`;
        http.open('GET', url, true);
        http.onreadystatechange = () => {
            if (http.readyState === 4 && http.status === 200 && http.response !== null) {
                resolve(http);
            } else if (http.readyState === 4 && http.status !== 200) {
                reject(http);
            }
        };
        http.send();
    });
};
